import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import Header from '../Header';
import StructuredData from '../SEO/StructuredData';

export default function Layout() {
  return (
    <>
      <StructuredData />
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}
